import {useEffect, useState} from 'react'
import {parseDailySoldReportRowData} from '../../utils'
import DailySoldReportChildTable from './DailySoldReportChildTable'

function DailySoldReportTableRow({row: rowData, monthly_column_keys}: any) {
  const row = parseDailySoldReportRowData(rowData)
  const [showDefaultChildTable, setShowDefaultChildTable] = useState(false)

  useEffect(() => {
    setShowDefaultChildTable(false)
  }, [rowData])

  return (
    <>
      <tr>
        <td className='ps-2'>
          {row?.child_data.length > 0 &&
            (showDefaultChildTable ? (
              <span onClick={() => setShowDefaultChildTable(!showDefaultChildTable)}>
                <i className='bi bi-dash-circle fs-3 fw-semibold cursor-pointer'></i>
              </span>
            ) : (
              <span onClick={() => setShowDefaultChildTable(!showDefaultChildTable)}>
                <i className='bi bi-plus-circle fs-3 fw-semibold cursor-pointer'></i>
              </span>
            ))}
        </td>

        <td>
          <div className='align-items-center'>{row['parent_sku']}</div>
        </td>
        <td>
          <div className='d-flex align-items-center py-2'>
            <div className='symbol symbol-40px me-3 border'>
              <img src={row.thumbnail_url} alt={row.product_title} />
            </div>
            <div className='d-flex flex-column'>
              <span>{row['product_title']}</span>
            </div>
          </div>
        </td>

        <td>
          <div className='text-center'>{row['reserved_quantity']}</div>
        </td>

        <td>
          <div className='text-center'>{row['quantity_available']}</div>
        </td>

        <td className='border-end'>
          <div className='text-center'>{row['quantity_incoming']}</div>
        </td>

        {monthly_column_keys &&
          monthly_column_keys !== undefined &&
          monthly_column_keys.map((column: any) => (
            <td>
              <div className='align-items-center text-center'>{rowData[column]}</div>
            </td>
          ))}

        <td>
          <div className='text-center'>{row['total_month_quantity']}</div>
        </td>
      </tr>
      {showDefaultChildTable && (
        <tr>
          <td colSpan={7 + monthly_column_keys.length}>
            <DailySoldReportChildTable child_data={row?.child_data} />
          </td>
        </tr>
      )}
    </>
  )
}

export default DailySoldReportTableRow
